<template>
  <template-manager-steps></template-manager-steps>
</template>

<script>
import TemplateManagerSteps from "./template-steps.vue";
export default {
  components: { TemplateManagerSteps },
};
</script>